import React from "react";
import { withNavBars } from "../../HOCs";
import ProfileEdit  from "./profileEdit";

class ProfileEditParent extends React.Component {
  render() {
    return <ProfileEdit {...this.props} />;
  }
}
const props = { boxShadow: false }

export default withNavBars(ProfileEditParent, props);
